/* ============================================
   BASE JS — Custom Shopify Theme
   ============================================ */

(function () {
  'use strict';

  /* --- DOM Ready Helper --- */
  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* --- Fetch Wrapper --- */
  function fetchJSON(url, options) {
    var defaults = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    };
    var config = Object.assign({}, defaults, options || {});
    return fetch(url, config).then(function (response) {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.status);
      }
      return response.json();
    });
  }

  /* --- Custom Event Dispatcher --- */
  function dispatchThemeEvent(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, { detail: detail || {}, bubbles: true })
    );
  }

  /* --- Cart API Helpers --- */
  var Cart = {
    get: function () {
      return fetchJSON('/cart.js');
    },

    add: function (items) {
      return fetchJSON('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: Array.isArray(items) ? items : [items] }),
      }).then(function (data) {
        dispatchThemeEvent('theme:cart:updated', data);
        return data;
      });
    },

    update: function (updates) {
      return fetchJSON('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ updates: updates }),
      }).then(function (data) {
        dispatchThemeEvent('theme:cart:updated', data);
        return data;
      });
    },

    change: function (line, quantity) {
      return fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function (data) {
        dispatchThemeEvent('theme:cart:updated', data);
        return data;
      });
    },

    clear: function () {
      return fetchJSON('/cart/clear.js', {
        method: 'POST',
      }).then(function (data) {
        dispatchThemeEvent('theme:cart:updated', data);
        return data;
      });
    },
  };

  /* --- Section Rendering Helper --- */
  function renderSection(sectionId) {
    var url = window.location.pathname + '?section_id=' + sectionId;
    return fetch(url).then(function (response) {
      return response.text();
    });
  }

  /* --- Debounce Utility --- */
  function debounce(fn, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay || 250);
    };
  }

  /* --- Quantity Input Component --- */
  function initQuantityInputs() {
    document.querySelectorAll('.quantity-input').forEach(function (wrapper) {
      var input = wrapper.querySelector('.quantity-input__field');
      var btnMinus = wrapper.querySelector('.quantity-input__btn--minus');
      var btnPlus = wrapper.querySelector('.quantity-input__btn--plus');

      if (!input || !btnMinus || !btnPlus) return;

      btnMinus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        if (current > min) {
          input.value = current - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      btnPlus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || 9999;
        if (current < max) {
          input.value = current + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  /* --- Mobile Menu Toggle --- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var close = document.querySelector('[data-menu-close]');
    var overlay = document.querySelector('[data-menu-overlay]');

    if (!toggle || !drawer) return;

    function openMenu() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-active');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
  }

  /* --- Accordion / Collapsible --- */
  function initCollapsibles() {
    document.querySelectorAll('[data-collapsible-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var content = this.nextElementSibling;
        var isOpen = this.classList.contains('is-open');

        this.classList.toggle('is-open');
        if (content) {
          content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
          content.classList.toggle('is-open');
        }

        this.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  /* --- Initialize on DOM Ready --- */
  onReady(function () {
    initQuantityInputs();
    initMobileMenu();
    initCollapsibles();
  });

  /* --- Shopify Theme Editor Events --- */
  document.addEventListener('shopify:section:load', function () {
    initQuantityInputs();
    initCollapsibles();
  });

  /* --- Expose to global scope --- */
  window.theme = window.theme || {};
  window.theme.Cart = Cart;
  window.theme.fetchJSON = fetchJSON;
  window.theme.renderSection = renderSection;
  window.theme.debounce = debounce;
  window.theme.dispatchEvent = dispatchThemeEvent;
})();
